import React, { useState } from "react";
import styled from "styled-components";
import bgEmpty from 'static/bg-empty.png'
import thumbnail from 'static/game-thumbnail.png'
import icBack from "static/ic-back.png"
import './styles.scss';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import icNext from 'static/ic-next.png';
import icPrevious from 'static/ic-previous.png';
// import { isAfter, renderDate } from "helpers/helpers";
import { history } from "store";
import { MAX_POINT_PER_DAY, MODAL_TYPE, NATIVE_ACTION } from "helpers/constants";
import ModalInfo from "../Dashboard/components/ModalInfo";
import { connect } from "react-redux";
import { getInfo } from "services";
import ModalUnexpected from "components/ModalUnexpected";
import { handleNativeAction } from "helpers/nativeActions";
import moment from "moment";
import { getGameAsset } from "helpers/gameAssets";
import mb32Thumbnail from 'static/mb32/img-quayOng-new.png'
import mb32BgModal from 'static/mb32/bg-modal.png'

const CustomLeftArrow = ({ onClick, ...rest }) => {
    return (
        <div
            style={{
                position: "absolute",
                left: 0,
                maxHeight: "2.5rem",
                maxWidth: "2.5rem",
                top: "35%"
            }}
            onClick={() => onClick()}
        >
            <img src={icPrevious} />
        </div>
    )
};

const CustomRightArrow = ({ onClick, ...rest }) => {
    return (
        <div
            style={{
                position: "absolute",
                right: 0,
                maxHeight: "2.5rem",
                maxWidth: "2.5rem",
                top: "35%"
            }}
            onClick={() => onClick()}
        >
            <img src={icNext} />
        </div>
    )
};

const Wrapper = styled.div`
    width: 100vw;
    height: 100vh;
    background-image: url(${bgEmpty});
    padding: 1.5rem;
    background-repeat: no-repeat;
    background-size: cover;
    `
const Container = styled.div`
    position: relative;
    display: flex;
    font-size:.875rem;
    margin-left: 2.5rem;
    line-height: 1.25rem;
    letter-spacing: 0.02em;
    text-align: left;
    `

const Upcoming = styled.p`
    min-width: fit-content;
    align-content: center;
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.5775rem;
    letter-spacing: 0.1em;
    background: linear-gradient(88.5deg, #FFBEA9 10.19%, #FFB6F3 74.48%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 1px 1px 10px rgba(255, 188, 188, 1);
    // margin-right: 10.5rem;
`

const Loading = styled.div`
    position: absolute;
    float: none;
    background: transparent;
    padding-top: 40vh;
`

const Spinner = styled.div`
    border: 3px solid red;
    border-right-color: transparent;
`
const ListGame = (props) => {
    const userGameCodeList = props.location.state?.userGameCodeList ? [...props.location.state?.userGameCodeList] : [];
    const [modal, openModal] = useState(null);
    const [selectedGameCode, setSelectedGameCode] = useState(null);
    const [config, setConfigModal] = useState({
        message: undefined,
        btnLabel: "Đóng",
        callback: () => openModal(null)
    });
    const [loading, setLoading] = useState(false);
    const startGame = async (gameCode, endDate) => {
        setSelectedGameCode(gameCode);
        setLoading(true);
        const gameInfo = await props.getInfo({ gameCode: gameCode });
        setLoading(false);
        if (gameInfo && gameInfo.result.ok) {
            handleNativeAction(NATIVE_ACTION.INS_QUAYONG_VIEW, { ins_transaction_amount_int: gameInfo.currentPoint, ins_transaction_type: "vao_game" });
            history.push("/home", { gameCode: gameCode, gameInfo: gameInfo, endDate: endDate });
        } else if (gameInfo && !gameInfo.result.ok && (gameInfo.result.responseCode === "GW100" || gameInfo.result.responseCode === "GW582")) {
            // Expired while call info
            openGameExpired();
        }
        else {
            openModal(MODAL_TYPE.UN_EXPECTED);
        }
    }

    const openGameExpired = () => {
        setConfigModal({
            message: "Chương trình đã kết thúc. Vui lòng theo dõi các chương trình khuyến mãi tiếp theo từ MBBank nhé.",
            btnLabel: "Đóng",
            callback: () => openModal(null)
        });
        openModal(MODAL_TYPE.UN_EXPECTED);
    }
    const handleStartGame = (gameCode, endDate) => {
        setSelectedGameCode(gameCode);
        const expired = endDate.split(" ")[0] + " " + endDate.split(" ")[1];
        if (moment(expired, "YYYY-MM-DD HH:mm:ss").isAfter(new Date())) {
            startGame(gameCode, endDate);
        } else {
            openGameExpired();
        }
    }
    const StatusButton = ({ status, gameCode, endDate }) => {
        switch (status) {
            case "ACTIVE":
                return <p className="absolute linear-button" style={{ bottom: ".5rem" }} onClick={() => handleStartGame(gameCode, endDate)}>QUAY THƯỞNG NGAY</p>;
            case "UPCOMING":
                return <div className="absolute d-flex justify-content-between bottom-0" style={{ width: `calc(100% - 220px - 40px)` }}>
                    <Upcoming>Sắp diễn ra</Upcoming>
                    <p className="linear-button" style={{ minWIdth: "fit-content" }} onClick={() => {
                        setSelectedGameCode(gameCode);
                        openModal(MODAL_TYPE.INFO);
                    }}>TÌM HIỂU THÊM</p>
                </div>
            default: // INACTIVE
                return <p className="absolute linear-button" style={{ bottom: ".5rem" }} onClick={() => {
                    setSelectedGameCode(gameCode);
                    openModal(MODAL_TYPE.INFO);
                }}>TÌM HIỂU THÊM</p>
        }
    }
    const Game = ({ game }) => {
        return (
            <Container className="game-container">
                <img src={getGameAsset(game.gameCode, 'img-quayOng-new', mb32Thumbnail)} alt="thumbnail" style={{ height: "14.625rem", width: "14.625rem" }} />
                <div className="game-content">
                    <div className="game">
                        <p className="text-glow game-name truncate">{game.gameName}</p>
                        <p className="date-label" style={{ visibility: "hidden" }}>{`${new Date(game.startDate.split(" ")[0]).toLocaleDateString()} - ${new Date(game.startDate.split(" ")[0]).toLocaleDateString()}`}</p>
                        <p className="description">{game.description}</p>
                    </div>
                    <StatusButton status={game.userGameStatus} gameCode={game.gameCode} endDate={game.endDate} />
                </div>
            </Container>
        )
    };

    return (
        <Wrapper
            className="listgame"
            style={{
                backgroundImage: `url(${getGameAsset(userGameCodeList[0]?.gameCode, 'bg-empty', bgEmpty)})`,
            }}
        >
            <div className="d-flex align-items-center" style={{ marginLeft: "2.5rem" }}>
                <img className="icon-header" src={icBack} alt="ic-back" onClick={() => handleNativeAction(NATIVE_ACTION.ONG_VANG_WEB, { action: "quit" })} />
                {/* <div className="title">DANH SÁCH CHƯƠNG TRÌNH</div> */}
            </div>
            <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={false}
                className="game-carousel"
                containerClass=""
                dotListClass=""
                draggable
                focusOnSelect={false}
                // infinite
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                customRightArrow={<CustomRightArrow />}
                customLeftArrow={<CustomLeftArrow />}
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={{
                    desktop: {
                        breakpoint: {
                            max: 3000,
                            min: 1024
                        },
                        items: 1
                    },
                    mobile: {
                        breakpoint: {
                            max: 464,
                            min: 0
                        },
                        items: 1
                    },
                    tablet: {
                        breakpoint: {
                            max: 1024,
                            min: 464
                        },
                        items: 1
                    }
                }}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                {userGameCodeList.map((item, index) => <Game game={item} key={index} />)}
            </Carousel>
            <ModalInfo
                isOpen={modal === MODAL_TYPE.INFO}
                onCloseModal={() => openModal(null)}
                gameCode={selectedGameCode} 
                backgroundImage={`url(${getGameAsset(selectedGameCode, 'bg-modal', mb32BgModal)})`} />
            {modal === MODAL_TYPE.UN_EXPECTED && <ModalUnexpected
                isOpen={modal === MODAL_TYPE.UN_EXPECTED}
                onCloseModal={config.callback}
                message={config.message}
                btnLabel={config.btnLabel}
                gameCode={selectedGameCode} />}
            {loading && <Loading className="overlay">
                <Spinner className="spinner" />
            </Loading>}
        </Wrapper>
    )
}

const mapDispatchToProps = dispatch => ({
    getInfo: params => dispatch(getInfo(params)),
});

export default connect(null, mapDispatchToProps)(ListGame);